import { createContext, useContext } from 'react';
import { EnableNotificationToast } from './EnableNotificationToast';
import { useInAppMessage } from './useInAppMessage';
import { useOneSignal } from './useOneSignal';

const NotificationContext = createContext<{
  oneSignal: ReturnType<typeof useOneSignal> | null;
  inAppMessage: ReturnType<typeof useInAppMessage> | null;
}>({
  oneSignal: null,
  inAppMessage: null,
});

export const NotificationProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const oneSignal = useOneSignal();
  const inAppMessage = useInAppMessage();

  return (
    <NotificationContext.Provider value={{ oneSignal, inAppMessage }}>
      {children}
      <EnableNotificationToast />
    </NotificationContext.Provider>
  );
};

export const useNotificationContext = () => useContext(NotificationContext)!;
